import * as DayStyles from './components/Day/Day.css';
import * as WeekCalendar from './components/WeekCalendar.css';
import * as SliderStyles from './components/Slider/Slider.css';

const defaultTheme = {
	WeekCalendar,
	DayStyles,
	SliderStyles
};

export default defaultTheme;
